module.exports = __webpack_public_path__ + "img/vision.2521ae46.jpg";